import React, { useEffect } from 'react';
import './Sobre.css';
import '../../../src/styles/mediaqueries.css';

const Sobre = () => {
    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://static.elfsight.com/platform/platform.js';
        script.async = true;
        document.body.appendChild(script);
    
        return () => {
          document.body.removeChild(script);
        };
      }, []);

  return (
    <section className="about-us">
        <div className='container'>
            <div className='about-container'>
                <div className='about-text'>
                    <div id='about' className='section-title'>Sobre nós</div>
                    <div id='about-desc' className='section-description'>
                        A clínica <strong>Família Singular</strong> é um espaço dedicado ao <strong>desenvolvimento de crianças e suas famílias</strong>.<br /><br /> Nossa missão é oferecer <strong>suporte especializado</strong>, <strong>acolhimento</strong> e <strong>orientação</strong> para que cada criança possa explorar seu potencial de forma singular.<br /><br /> Contamos com uma <strong>equipe multidisciplinar</strong> de profissionais apaixonados e experientes, que trabalham para promover <strong>autonomia</strong>, <strong>bem-estar emocional</strong> e <strong>aprendizado</strong>.
                    </div>
                </div>
                <div className='about-video'>
                    <div class="elfsight-app-656f6f9d-73e2-412a-bb1c-ab6db484ce4c" data-elfsight-app-lazy></div>
                </div>
            </div>
        </div>

        <script type="module" src="https://unpkg.com/ionicons@7.1.0/dist/ionicons/ionicons.esm.js"></script>
        <script nomodule src="https://unpkg.com/ionicons@7.1.0/dist/ionicons/ionicons.js"></script>
    </section>
  );
};

export default Sobre;
